// -------------
// this is the registration of all default flow step runners
// -------------

import { RegisterFlowStepRunner } from "./RegisterFlowStepRunner";
import { MultiOutputTestStepRunner } from "../Steps/ExampleSteps/MultiOutputTestStepRunner";
import { ManyOutputTestStepRunner } from "../Steps/ExampleSteps/ManyOutputTestStepRunner";
import { MultiOutputTestStep } from "../Steps/ExampleSteps/MultiOutputTestStep";
import { ManyOutputTestStep } from "../Steps/ExampleSteps/ManyOutputTestStep";
import { LongOutputTestStepRunner } from "../Steps/ExampleSteps/LongOutputTestStepRunner";
import { LongOutputTestStep } from "../Steps/ExampleSteps/LongOutputTestStep";
import { RunExpressionRunner } from "../Steps/Expressions/RunExpressionRunner";
import { RunExpression } from "../Steps/Expressions/RunExpression";
import { RunStatementRuleRunner } from "../Steps/Rules/RunStatementRuleRunner";
import { RunStatementRule } from "../Steps/Rules/RunStatementRule";
import { RunRuleTableRunner } from "../Steps/Rules/RunRuleTableRunner";
import { RunRuleTable } from "../Steps/Rules/RunRuleTable";
import { RunValueTableRunner } from "../Steps/Rules/RunValueTableRunner";
import { RunValueTable } from "../Steps/Rules/RunValueTable";
import { RunIntersectionRuleRunner } from "../Steps/Rules/RunIntersectionRuleRunner";
import { RunIntersectionRule } from "../Steps/Rules/RunIntersectionRule";
import { RunTreeRuleRunner } from "../Steps/Rules/RunTreeRuleRunner";
import { RunTreeRule } from "../Steps/Rules/RunTreeRule";
import { RunRuleSetRunner } from "../Steps/Rules/RunRuleSetRunner";
import { RunRuleSet } from "../Steps/Rules/RunRuleSet";
import { RunFlowRunner } from "../Steps/General/RunFlowRunner";
import { RunFlow } from "../Steps/General/RunFlow";
import { SaveFlowDataRunner } from "../Steps/General/SaveFlowDataRunner";
import { SaveFlowData } from "../Steps/General/SaveFlowData";
import { LogStepRunner } from "../Steps/General/LogStepRunner";
import { LogStep } from "../Steps/General/LogStep";
import { FormStepRunner } from "../Steps/UI/FormStepRunner";
import { FormStep } from "../Steps/UI/FormStep";

export class RegisterFlowStepRunners {
    static isRegistered = false;

    static doRegistration() {
        if (RegisterFlowStepRunners.isRegistered) return;

        RegisterFlowStepRunners.isRegistered = true;

        RegisterFlowStepRunner(new MultiOutputTestStepRunner(), new MultiOutputTestStep());
        RegisterFlowStepRunner(new ManyOutputTestStepRunner(), new ManyOutputTestStep());
        RegisterFlowStepRunner(new LongOutputTestStepRunner(), new LongOutputTestStep());

        RegisterFlowStepRunner(new FormStepRunner(), new FormStep());

        RegisterFlowStepRunner(new RunExpressionRunner(), new RunExpression());

        RegisterFlowStepRunner(new RunStatementRuleRunner(), new RunStatementRule());
        RegisterFlowStepRunner(new RunRuleTableRunner(), new RunRuleTable());
        RegisterFlowStepRunner(new RunValueTableRunner(), new RunValueTable());
        RegisterFlowStepRunner(new RunIntersectionRuleRunner(), new RunIntersectionRule());
        RegisterFlowStepRunner(new RunTreeRuleRunner(), new RunTreeRule());
        RegisterFlowStepRunner(new RunRuleSetRunner(), new RunRuleSet());

        RegisterFlowStepRunner(new RunFlowRunner(), new RunFlow());
        RegisterFlowStepRunner(new SaveFlowDataRunner(), new SaveFlowData());

        RegisterFlowStepRunner(new LogStepRunner(), new LogStep());
    }
}
